import { cn } from '##/utils/bem';

export const cnBadge = cn('Badge');
